/**
 * Shown when a render error escapes every screen. The error itself has already
 * gone to PostHog Error tracking by the time this mounts, so all this needs to
 * do is give the person a way back in. Styled inline because the crash may
 * have come from anywhere, including the stylesheet's consumers.
 */
export function CrashScreen() {
  return (
    <div
      role="alert"
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: 24,
        textAlign: 'center',
        background: 'var(--c-bg, #fff)',
        color: 'var(--c-text, #222)',
      }}
    >
      <p style={{ fontFamily: 'var(--f-letter, serif)', fontSize: 22, margin: 0 }}>
        Something went wrong on our end.
      </p>
      <p style={{ margin: 0, opacity: 0.75 }}>Your letters are safe. Reloading usually sorts it.</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          padding: '10px 20px',
          borderRadius: 999,
          border: 'none',
          background: 'var(--c-accent, #7B5244)',
          color: '#fff',
          font: 'inherit',
          cursor: 'pointer',
        }}
      >
        Reload
      </button>
    </div>
  );
}
